import { memo } from 'react';
import {
    Divider, Interpolate, Message, Tooltip
} from '@wg/wows-react-uikit';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { ItemTypes } from '@wg/wows-entities/const';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './RewardShipTooltip.scss';
import type { IReward, GameItemReward } from '~/types';
import { SecondaryShipDisclaimer, MainShipDisclaimer } from '~/Components/Tooltips/Tooltips';
import { ship } from '~/wowsEntities';
import { GRADES } from '~/constants';

interface IRewardShipTooltipProps {
    id: string,
    reward?: IReward,
    isPremium?: boolean,
    isCollected?: boolean,
    isFreeMainReward?: boolean,
    secondaryShip?: GameItemReward | null,
}

const RewardShipTooltip = (props: IRewardShipTooltipProps) => {
    const { t } = useTranslation();
    const {
        id, reward, isPremium, isCollected, secondaryShip, isFreeMainReward
    } = props;

    const renderTitle = () => {
        switch (reward?.grade) {
            case GRADES.BRONZE:
            case GRADES.SILVER: {
                return <Interpolate str={t('Особая награда за %(level)s этап')} level={reward?.shipLevelNumber} />;
            }
            case GRADES.GOLD: {
                return t('Финальная награда');
            }
            default: {
                return <Interpolate str={t('Награда за %(level)s этап')} level={reward?.shipLevelNumber} />;
            }
        }
    };

    const header = classnames(styles.header, {
        [styles.receivedReward]: isCollected,
    });

    const shipImageStyles = {
        backgroundImage: `url(${reward?.tooltipImage})`,
    };

    const isSecondaryShip = secondaryShip?.id === id;

    return (
        <Tooltip className={styles.tooltip}>
            <div className={styles.wraper}>
                <div className={header}>{renderTitle()}</div>
            </div>
            <Divider type={'major'} />
            {reward?.tooltipImage && (
                <>
                    <div className={styles.imageHolder}>
                        <div style={shipImageStyles} className={styles.image} />
                    </div>
                    <Divider type={'major'} />
                </>
            )}
            <div className={styles.shipName}>
                {ship(id)}
            </div>
            <div className={styles.tth}>
                <WoWSEntity
                    type={ItemTypes.SHIP_TTC}
                    id={id}
                    presentation={{
                        withTooltip: false,
                    }}
                />
            </div>
            {isCollected && (
                <>
                    <Divider type={'major'} />
                    <div className={styles.row}>
                        <Message style={'inline'} type={'done'}>
                            {t('Получено')}
                        </Message>
                    </div>
                </>
            )}
            {isSecondaryShip
                ? (
                    <SecondaryShipDisclaimer
                        secondaryShip={secondaryShip}
                    />
                )
                : (
                    <MainShipDisclaimer
                        isPremium={isPremium}
                        isFreeMainReward={isFreeMainReward}
                        secondaryShip={secondaryShip}
                    />
                )
            }
        </Tooltip>
    );
};

export default memo(RewardShipTooltip, () => true);
